import React, { useContext, useEffect, Fragment } from "react";
import { useParams } from "react-router-dom";
import { TipoContatoContext } from "../TipoContatoContext";
import Formulario from "../../../../../Components/Cadastro/Formulario/Formulario";

const FormularioTipoContato = () => {
  const { values, setValues, getDetailHandler } = useContext(
    TipoContatoContext
  );
  let { id } = useParams();

  useEffect(() => {
    getDetailHandler(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      data: {
        ...values.data,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Formulario context={TipoContatoContext}>
        <div className="col-12 col-md-5 form-group">
          <label>Descrição</label>
          <input
            disabled={values.formDisabled}
            className="form-control uppercase"
            type="text"
            maxLength="40"
            name="tipoContatoDescricao"
            value={values.data.tipoContatoDescricao}
            onChange={onChangeInput}
          />
        </div>
        <div className="col-12 col-md-2 form-group">
          <label>Status</label>
          <select
            disabled={values.formDisabled}
            className="form-control"
            name="tipoContatoAtivo"
            value={values.data.tipoContatoAtivo}
            onChange={onChangeInput}
          >
            <option value="A"> Ativo </option>
            <option value="I"> Inativo </option>
          </select>
        </div>
      </Formulario>
    </Fragment>
  );
};

export default FormularioTipoContato;
